/**
 * Created by sswaminathan on 2/4/22
 * File: CapacityCalculator.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css
import { useFormContext } from 'react-hook-form'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS_EDITION, APP_ID_TRAFFIC_MIRRORING,
} from '../../../../../common/constants/GlobalConstants'
import {
  QUANTITY_CALCULATE_BY_BASE,
  SUBSCRIPTION_ACTION_EDIT,
  URL_VALIDATIONS
} from '../../../constants/SubscriptionConstant'

/**
 *   TODO: Brief what is this component/class do
 */

const CapacityCalculator = (rest) => {
  const { licenseAction, licenseInfo, product, allocation, isCasb, productInformation } = rest
  const { getValues } = useFormContext()
  const validationFailureOnAdd = (product) => {
    if (allocation) {
      return product.purchased_size
    }
    if (product.app_id === APP_ID_PRISMA_ACCESS_EDITION && product.license_type.includes('GBL')) {
      return product.purchased_size < 1000 ? product.purchased_size : 1000
    }
    else if (product.app_id === APP_ID_PRISMA_ACCESS_EDITION) {
      return product.purchased_size < 200 ? product.purchased_size : 200
    }
    else {
      return product.min_quantity ? product.min_quantity : product.purchased_size
    }
  }
  const calculateMaxUsingBaseQuantity = (() => {
    const productInfo = productInformation?.find((each) => each.products)
    if (productInfo && product.app_id !== APP_ID_TRAFFIC_MIRRORING) {
      let totalCount = 0
      productInfo?.products?.forEach(({ formFieldName, license_type }) => {
        if (product.license_type.includes('MU') && license_type.includes('MU')) {
          totalCount = totalCount + +getValues(formFieldName)
        }
        else if (product.license_type.includes('RN') && license_type.includes('RN')) {
          totalCount = totalCount + +getValues(formFieldName)
        }
      })
      return totalCount
    }
    else if (productInfo && product.app_id === APP_ID_TRAFFIC_MIRRORING) {
      return productInfo?.products?.reduce((result, each) => {
        if (each.license_type.includes('MU')) {
          const value = getValues(each.formFieldName)
          result = result + (typeof value === 'number' ? +value : 0)
        }
        return result
      }, 0)
    }
  })

  const validation = rest.validation[rest.licenseValue] ? rest.validation[rest.licenseValue][product.app_id] : []
  //NEED to validate Service connection once the API is up.
  if (licenseAction === SUBSCRIPTION_ACTION_EDIT && licenseInfo) {
    let appInformation = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION] ?
      licenseInfo[APP_ID_PRISMA_ACCESS_EDITION].entitlements.find((each) => {
        return product.app_id.concat('-', product.license_type) === each.app_id.concat('-', each.license_type) && each.purchased_size
      }) : false
    appInformation = (!appInformation && product.app_id === APP_ID_LOGGING_SERVICE) ? licenseInfo[APP_ID_LOGGING_SERVICE] : appInformation
    if (appInformation) {
      return appInformation && (product.app_id === APP_ID_LOGGING_SERVICE) ? appInformation.extra.purchased_size : appInformation.purchased_size
    }
  }
  //To handle the CASB and make the minimum quantity equal to the base license , incase of split.
  if (isCasb) {
    const paeValidation = rest.validation[rest.licenseValue] ? rest.validation[rest.licenseValue][APP_ID_PRISMA_ACCESS_EDITION][0] : {}
    if (allocation) {
      return product?.purchased_size
    }
    return paeValidation.min_quantity ?? product?.purchased_size
  }
  else if (QUANTITY_CALCULATE_BY_BASE.has(product?.app_id)) {
    // This is to calculate the ADEM quantity based  on the base line quantity entered
    return calculateMaxUsingBaseQuantity()
  }
  else if (!URL_VALIDATIONS.includes(product.app_id)) {
    if (allocation) {
      return product.purchased_size
    }
    if (validation?.length > 0) {
      const validationResponse = validation.find(({ app_id, license_type }) => (app_id + license_type) === (product.app_id + product.license_type))
      // if (validationResponse?.app_id === APP_ID_AUTONOMOUS_DEM) {
      //   validationResponse.max_quantity = calculateMaxUsingBaseQuantity()
      // }
      if (validationResponse) {
        //TODO: After PAE fix
        if (validationResponse?.min_quantity && validationResponse?.min_quantity < product.purchased_size) {
          return validationResponse?.min_quantity
        }
      }
      return product.purchased_size
    }
    else {
      return validationFailureOnAdd(product)
    }
  }
}


export default CapacityCalculator
